module.exports = __webpack_public_path__ + "img/zhcg.134c685d.png";